<ng-container *ngIf="currentLang$ | async as current">
  <ng-container *ngFor="let locale of locales | keyvalue">
    <a href="javascript:;" *ngIf="locale.key !== current" (click)="switchTo(locale.key)">
      {{ locale.value.title }}
    </a>
  </ng-container>
</ng-container>
